
import { computed, defineComponent } from 'vue';
/* eslint-disable import/no-cycle */
import { useMainStore } from '@/store/mainStore';
import AppAddButton from '@/components/UI/AppAddButton.vue';
import AppAlert from '@/components/UI/AppAlert.vue';
import AppButton from '@/components/UI/AppButton.vue';
import AppCheckbox from '@/components/UI/AppCheckbox.vue';
import AppCircleActionMenu from '@/components/UI/AppCircleActionMenu.vue';
import AppDatePicker from '@/components/UI/AppDatePicker.vue';
import AppDropdown from '@/components/UI/AppDropdown.vue';
import AppFormItem from '@/components/UI/AppFormItem.vue';
import AppInput from '@/components/UI/AppInput.vue';
import AppLabelInput from '@/components/UI/AppLabelInput.vue';
import AppLazyImage from '@/components/UI/AppLazyImage.vue';
import AppLink from '@/components/UI/AppLink.vue';
import AppLoader from '@/components/UI/AppLoader.vue';
import AppMessageInput from '@/components/UI/AppMessageInput.vue';
import AppProgress from '@/components/UI/AppProgress.vue';
import AppSearch from '@/components/UI/AppSearch.vue';
import AppSelect from '@/components/UI/AppSelect.vue';
import AppSmallLoader from '@/components/UI/AppSmallLoader.vue';
import AppUploadInfo from '@/components/UI/AppUploadInfo.vue';

export default defineComponent({
  components: {
    AppAddButton,
    AppAlert,
    AppButton,
    AppCheckbox,
    AppCircleActionMenu,
    AppDatePicker,
    AppDropdown,
    AppFormItem,
    AppInput,
    AppLabelInput,
    AppLazyImage,
    AppLink,
    AppLoader,
    AppMessageInput,
    AppProgress,
    AppSearch,
    AppSelect,
    AppSmallLoader,
    AppUploadInfo,
  },
  setup() {
    const mainStore = useMainStore();
    const error = 'Some Error';
    const mobileView = computed(() => mainStore.isMobile);
    return {
      mainStore,
      error,
      mobileView,
    };
  },
});
